type PreloadedImage = {
  image: HTMLImageElement | HTMLVideoElement,
  src: string,
}

export default class ContainerFeaturesScreenshot {
  domRoot: HTMLElement;
  params: any;
  preloadedImages: { desktop: PreloadedImage[]; mobile: PreloadedImage[]; };
  defaultImage: HTMLImageElement;
  mobileImage: HTMLImageElement;
  featureContainer: any;
  imageContainer: any;
  featureCards: any;
  desktopImageContainer: any;
  mobileImageContainer: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.preloadedImages = {
      desktop: [],
      mobile: []
    };
    this.defaultImage = new Image();
    this.defaultImage.src = this.params.defaultImage;
    this.mobileImage = new Image();
    this.mobileImage.src = this.params.mobileImage;
    this.featureContainer = this.domRoot.querySelector('.imkt-features-screenshots__text-container');
    this.imageContainer = this.domRoot.querySelector('.imkt-features-screenshots__screenshot');
    this.featureCards = this.domRoot.querySelectorAll('.screenshot-desktop .imkt-features-screenshots__card');
    this.desktopImageContainer = this.domRoot.querySelector('.md-img');
    this.mobileImageContainer = this.domRoot.querySelector('.xs-img');
    this.init();
  }

  init() {
    this.preloadImages('desktop');
    this.preloadImages('mobile');
    this.bindEvents();
  }

  isVisible(element: any) {
    return element.offsetParent != null;
  }

  bindEvents() {
    this.featureCards.forEach((featureCard, index) => {
      featureCard.addEventListener('mouseenter', () => {
        this.featureCards.forEach(card => { card.parentNode.classList.remove('active') });
        featureCard.parentNode.classList.add('active');
        this.updateImage(index);
      });
    })
  }

  preloadImages(type: 'mobile' | 'desktop') {
    var preloadedImage;
    this.params.images[type].forEach((src) => {

      var newImage;
      if (src.includes("mp4")) {
        newImage = document.createElement("video");
        newImage.autoplay = true;
        newImage.muted = true;
        newImage.loop = true;
        var srcer = document.createElement("source");
        srcer.src = src;
        srcer.type = "video/mp4";
        newImage.appendChild(srcer);
      } else {
        newImage = new Image();
      }
      newImage.src = src;
      preloadedImage = {
        image: newImage,
        src: newImage.src
      };
      this.preloadedImages[type].push(preloadedImage);
    });
  }

  updateImage(index: number) {
    this.desktopImageContainer.innerHTML = this.mobileImageContainer.innerHTML = '';

    let appenderImageDesk = this.preloadedImages.desktop[index].image;
    let appenderImageMob = this.preloadedImages.mobile[index].image;
    this.desktopImageContainer.appendChild(appenderImageDesk);
    this.mobileImageContainer.appendChild(appenderImageMob);
    if (appenderImageDesk.src.includes("mp4")) {
      if (this.isVisible(this.desktopImageContainer)) {
        appenderImageDesk.play();
      }
    }
    if (appenderImageMob.src.includes("mp4")) {
      if (this.isVisible(this.mobileImageContainer)) {
        appenderImageMob.play();
      }
    }
  }
  
  updateImageDefault() {
    this.desktopImageContainer.innerHTML = this.mobileImageContainer.innerHTML = '';
    this.desktopImageContainer.appendChild(this.defaultImage);
    this.mobileImageContainer.appendChild(this.mobileImage);
  }
}
